import { ENUM_STATUS_ATIVO } from 'utils/consts';

export const formatterServicoBackToFront = servicoApi => {
  return {
    nomeServico: servicoApi?.nome,
    descricaoServico: servicoApi?.descricao,
    documentos: servicoApi?.documentos,
    identificadorServico: servicoApi?.identificacao,
    situacaoId: servicoApi?.ativo ? ENUM_STATUS_ATIVO?.ATIVO?.value : ENUM_STATUS_ATIVO?.INATIVO?.value,
  };
};

export const formatterServicoFrontToBackCreate = dadosInputs => {
  const statusAtivo = dadosInputs?.situacaoId === ENUM_STATUS_ATIVO?.ATIVO?.value ? true : false;
  return {
    nome: dadosInputs?.nomeServico,
    descricao: dadosInputs?.descricaoServico,
    documentos: dadosInputs?.documentos,
    identificacao: dadosInputs?.identificadorServico,
    ativo: statusAtivo,
    assuntoId: 2,
    id: 0,
  };
};

export const formatterServicoFrontToBackUpdate = (dadosInputs, id) => {
  const statusAtivo = dadosInputs?.situacaoId === ENUM_STATUS_ATIVO?.ATIVO?.value ? true : false;
  return {
    nome: dadosInputs?.nomeServico,
    descricao: dadosInputs?.descricaoServico,
    documentos: dadosInputs?.documentos,
    identificacao: dadosInputs?.identificadorServico,
    ativo: statusAtivo,
    assuntoId: 2,
    id: id,
  };
};

export const formatterServicoNull = () => {
  return {
    nomeServico: '',
    descricaoServico: '',
    documentos: '',
    identificadorServico: '',
    situacaoId: '',
  };
};
